import { render, staticRenderFns } from "./DeckCardsConfiguration.vue?vue&type=template&id=02bc2e60&scoped=true"
import script from "./DeckCardsConfiguration.vue?vue&type=script&lang=js"
export * from "./DeckCardsConfiguration.vue?vue&type=script&lang=js"
import style0 from "./DeckCardsConfiguration.vue?vue&type=style&index=0&id=02bc2e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bc2e60",
  null
  
)

export default component.exports